import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-app-registration',
  imports: [],
  templateUrl: './icon-app-registration.component.html',
  styleUrl: './icon-app-registration.component.scss'
})
export class IconAppRegistrationComponent {

}
